import { IconClose } from "../../icon/variants/IconClose.js";
import { IconMyLocation } from "../../icon/variants/IconMyLocation.js";
import { Group } from "../../mantine-passthroughs/index.js";
import { IconButton } from "../../icon-button/IconButton.js";
import { Body1 } from "../../typography/Body1.js";
import { FormFieldError } from "../form-field-error/FormFieldError.js";
import inputs_module_default from "../inputs.module.js";
import { Autocomplete } from "@mantine/core";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/inputs/autocomplete/Autocomplete.tsx
/**
* Provides users a list of suggestions to select from based on the input
*/
const Autocomplete$1 = ({ data, defaultValue, description, disabled, error, filter, label, onBlur, onChange, onFocus, onKeyUp, onOptionSubmit, optionIcon, placeholder, rightSectionWidth = "3.25rem", secondaryRightSection, value, withErrorStyles = true, "data-testid": testId }) => {
	const inputRef = useRef(null);
	const [internalValue, setInternalValue] = useState(value ?? defaultValue ?? "");
	const hasValue = (value ?? internalValue).length !== 0;
	const handleChange = useCallback((changedValue) => {
		setInternalValue(changedValue);
		onChange?.(changedValue);
	}, [onChange]);
	const renderOption = useCallback((input) => {
		return /* @__PURE__ */ jsxs(Group, {
			gap: "sm",
			wrap: "nowrap",
			children: [input.option.value.includes("Current location") ? /* @__PURE__ */ jsx(IconMyLocation, { color: "primary" }) : optionIcon, /* @__PURE__ */ jsx(Body1, { children: input.option.value })]
		}, input.option.value);
	}, [optionIcon]);
	const clear = useCallback(() => {
		handleChange("");
		inputRef.current?.focus();
	}, [handleChange]);
	const resetButton = hasValue ? /* @__PURE__ */ jsx(IconButton, {
		Icon: IconClose,
		size: "sm",
		onClick: clear,
		color: "gray"
	}) : null;
	const rightSection = secondaryRightSection || resetButton ? /* @__PURE__ */ jsxs(Group, {
		gap: 8,
		wrap: "nowrap",
		children: [resetButton, secondaryRightSection]
	}) : null;
	const rightSectionProps = secondaryRightSection ? { className: inputs_module_default.rightSectionEnd } : void 0;
	const err = useMemo(() => {
		if (error && typeof error === "boolean") return true;
		if (error && typeof error === "string") return /* @__PURE__ */ jsx(FormFieldError, { errText: error });
		return null;
	}, [error]);
	return /* @__PURE__ */ jsx(Autocomplete, {
		ref: inputRef,
		"data-testid": testId,
		classNames: inputs_module_default,
		onBlur,
		onChange: handleChange,
		onFocus,
		onKeyUp,
		rightSection,
		rightSectionProps,
		description,
		label,
		data,
		filter,
		disabled,
		placeholder,
		onOptionSubmit,
		radius: "xxs",
		size: "xl",
		renderOption,
		rightSectionWidth,
		value: value ?? internalValue,
		labelProps: {
			"data-floating": hasValue,
			className: inputs_module_default.autocompletelabel
		},
		descriptionProps: { className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description },
		error: err,
		withErrorStyles,
		wrapperProps: { "data-with-error-styles": withErrorStyles ? "true" : "false" },
		inputWrapperOrder: error ? [
			"label",
			"input",
			"error"
		] : [
			"label",
			"input",
			"description"
		]
	});
};

//#endregion
export { Autocomplete$1 as Autocomplete };